module.exports = __webpack_public_path__ + "img/icon_benefit_02_w.3af6f007.svg";